import React, { useState, useEffect } from "react";
import "../Style/Navbar.css";
import logo from "../Assets/logo.png";
import { FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa";
import { FiMail, FiLogIn } from "react-icons/fi";
import { AiOutlineUserAdd } from "react-icons/ai";
import { FaLocationDot } from "react-icons/fa6";
import { MdCall } from "react-icons/md";
import { MdOutlinePersonAddAlt1 } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import Register from "./Register";
import Login from "./Login";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdCloseCircleOutline } from "react-icons/io";
import BookAppointment from "./BookAppointment";
import { useAppointment } from "./AppointmentContext.js";
import { MdAccountBox } from "react-icons/md";
import { useAuth } from "./UserContext.js";
const Navbar = () => {
  const {
    currentUser,
    isLoggedIn,
    logout,
    showRegisterComponent,
    showLoginComponent,
    setShowLoginComponent,
    setShowRegisterComponent,
    handleLoginComponent,
    handleRegisterComponent,
    openWhatsApp,
    makeCall,
    openGmail,
    options,
  } = useAuth();
  const { appointmentData, handleAppointment, setAppointmentData } =
    useAppointment();
  const navigate = useNavigate();
  const location = useLocation();
  const [showLocation, setShowLocation] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("Jaunpur");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // const [showRegisterComponent, setShowRegisterComponent] = useState(false);
  const [showMyProfile, setShowMyProfile] = useState(false);
  const [showBookAppointmentComponent, setShowBookAppointmentComponent] =
    useState(false);
  // const [showLoginComponent, setShowLoginComponent] = useState(false);
  const [showHamburgerOption, setShowHamburgerOption] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMyProfile = () => {
    setShowMyProfile(!showMyProfile);
  };

  const handleHamburgerOption = () => {
    setShowHamburgerOption(!showHamburgerOption);
  };
  return (
    <div className="header-container">
      <div className="top-bar">
        <div className="contact-info">
          <div className="contact-info-1">
            <FaWhatsapp
              size={30}
              onClick={openWhatsApp}
              style={{ cursor: "pointer" }}
            />
            <FaFacebook size={30} />
            <FaInstagram size={30} />
            <div
              style={{
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
              }}
              onClick={makeCall}
            >
              <MdCall size={30} />
              <p>+91 9129371733</p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={openGmail}
          >
            <FiMail size={30} />
            <p>rk@drrkvishwakarma.com</p>
          </div>
        </div>
        <div className="top-bar-location-btn">
          <div className="location">
            <FaLocationDot size={30} color="var(--primary-color)" />
            <span
              onClick={() => {
                setShowLocation(!showLocation);
              }}
            >
              {selectedLocation}
            </span>
          </div>
          {showLocation && (
            <div className="show-location-pos-1">
              {options?.location?.map((loc) => (
                <p
                  onClick={() => {
                    setSelectedLocation(loc);
                    setShowLocation(false);
                  }}
                >
                  {loc}
                </p>
              ))}
            </div>
          )}
          {!isLoggedIn ? (
            <div className="auth-buttons">
              <button className="login-btn" onClick={handleLoginComponent}>
                <FiLogIn /> Login
              </button>
              <button className="signup-btn" onClick={handleRegisterComponent}>
                <MdOutlinePersonAddAlt1 /> Sign up
              </button>
            </div>
          ) : (
            <div className="account-div" onClick={handleMyProfile}>
              <MdAccountBox size={40} />
              <p>My Profile</p>
            </div>
          )}
          {showMyProfile && (
            <div className="myprofile-option">
              <p
                onClick={() => {
                  navigate("/account");
                  setShowMyProfile(false);
                }}
              >
                My Profile
              </p>
              <p
                onClick={() => {
                  navigate("/myappointment");
                  setShowMyProfile(false);
                }}
              >
                My Appointment
              </p>
              {false && (
                <p
                  onClick={() => {
                    navigate("/myremedies");
                    setShowMyProfile(false);
                  }}
                >
                  My Remedies
                </p>
              )}
              <p
                onClick={() => {
                  logout();
                  navigate("/");
                  setShowMyProfile(false);
                }}
              >
                Logout
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="navbar">
        <div className="logo">
          <div className="logo-image">
            <img src={logo} alt="Logo" />
          </div>
          <div>
            <p className="logo-text">
              HOMOEOPATHIC HEALTH CARE & RESEARCH CENTER
            </p>
          </div>
        </div>
        {isMobile ? (
          <div className="mobile-hamburger-icon">
            <GiHamburgerMenu onClick={handleHamburgerOption} />
          </div>
        ) : (
          <ul className="menu">
            <li onClick={() => navigate("/")}>Home</li>
            <li onClick={handleAppointment}>Book Appointment</li>
            <li onClick={() => navigate("/ourtreatment")}>Our Treatments</li>
            <li onClick={() => navigate("/gallery")}>Gallery</li>
            <li onClick={() => navigate("/teams")}>Teams</li>
            <li onClick={() => navigate("/aboutus")}>About us</li>
            <li onClick={() => navigate("/contactus")}>Contact us</li>
          </ul>
        )}
      </div>

      {showHamburgerOption && (
        <div className="hamburger-option-1">
          <ul className="menu-1">
            <li
              onClick={() => {
                navigate("/");
                setShowHamburgerOption(false);
              }}
            >
              Home
            </li>
            <li
              onClick={() => {
                handleAppointment();
                setShowHamburgerOption(false);
              }}
            >
              Book Appointment
            </li>
            <li
              onClick={() => {
                navigate("/ourtreatment");
                setShowHamburgerOption(false);
              }}
            >
              Our Treatments
            </li>
            <li
              onClick={() => {
                navigate("/gallery");
                setShowHamburgerOption(false);
              }}
            >
              Gallery
            </li>
            <li onClick={() => navigate("/teams")}>Teams</li>
            <li
              onClick={() => {
                navigate("/aboutus");
                setShowHamburgerOption(false);
              }}
            >
              About us
            </li>
            <li
              onClick={() => {
                navigate("/contactus");
                setShowHamburgerOption(false);
              }}
            >
              Contact us
            </li>
          </ul>
          <div
            className="close-icon-1"
            onClick={() => setShowHamburgerOption(false)}
          >
            <IoMdCloseCircleOutline size={50} color="var(--primary-color)" />
          </div>
        </div>
      )}
      {location.pathname !== "/" && <div className="navbar-border-line"></div>}
      {showRegisterComponent && (
        <div className="popup-overlay" onClick={handleRegisterComponent}>
          <Register
            setShowRegisterComponent={setShowRegisterComponent}
            setShowLoginComponent={setShowLoginComponent}
          />
        </div>
      )}
      {showLoginComponent && (
        <div className="popup-overlay" onClick={handleLoginComponent}>
          <Login
            setShowLoginComponent={setShowLoginComponent}
            setShowRegisterComponent={setShowRegisterComponent}
          />
        </div>
      )}
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </div>
  );
};

export default Navbar;
